import $ from 'jquery';
import 'slick-carousel';

/**
 * Stage Class
 * @class Stage
 */

export default class Stage {
    slick;
    constructor() {
        if (document.getElementsByClassName('stage__slider').length) {
            this.slick = $('.slick__slides').slick({
                dots: true,
                infinite: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                autoplaySpeed:3000,
                autoplay:document.querySelector('.stage__slider').classList.contains("autoplay")
            });
        }
       
    }
}